






























































































































































































































































































































































































































































import { rollCallDetails } from "@/api/rollCallDetails";
import { dateFormat } from "@/utils/timeFormat";
import {
  rollCallListData,
  studentEdit,
  studentExceedHandle,
  exceedcode,
  courseAccount,
  lessonCancelRollCall,
} from "@/api/rollCallRecord";
import { rollCallStudentList } from "@/api/rollCall";
import { getstudentcount } from "@/api/studyDetails";
import { switchDetailApi } from "@/api/storeManagement";
import { getOperationLogInter, getOperationLogApi } from "@/api/store";
import dialogCombox from "./dialogCombox.vue";
import detailsDialog from "./detailsDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import studentDialog from "./studentDialog.vue";
@Component({
  name: "rollCallDetails",
  components: {
    dialogCombox,
    studentDialog,
    detailsDialog,
  },
})
export default class extends Vue {
  activeName = "studentlist";
  surplusCourse: boolean = false; // 显示剩余课时
  courseNum = ""; // 耗课数数
  tableData: any = [];
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 5;
  searchInfo = {};
  dialogVisible = false;
  followupList = [{ key: 1, value: "隐" }];
  dialogImageUrl = "";
  disabled = false;
  editbtn = true;
  detailsData = {
    class: {
      name: "",
    },
    course: {
      title: "",
    },
    teacher_list: [],
    class_lesson: {
      start_time: "",
      end_time: "",
    },
    class_lesson_extend: {
      content: "",
    },
  };
  id = 0;
  codeList = [];
  types = "";
  studentId = 0;
  dialogData = {
    lesson_date: "",
    lesson_start_time: "",
    lesson_end_time: "",
    consume_number: "",
    consume_class: "",
  };
  studentIdsList = [];
  studentcount = {};
  student_exceed: boolean = false;
  created() {
    this.init();
    switchDetailApi().then((res: any) => {
      if (res.error_code === 0) {
        this.student_exceed = res.data.student_exceed === 1;
      }
    });
  }
  updateList() {
    const _t = this;
    _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
  }
  init() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    if (_t.id) {
      _t.getData(_t.id);
      _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
      _t.getexceedcode();
      _t.getstudentcountData();
    }
  }
  getstudentcountData() {
    const _t = this as any;
    const data: any = {};
    data.roll_call_id = _t.id;
    getstudentcount(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.studentcount = res.data;
      }
    });
  }
  disabledClick(e: string) {
    const _t = this as any;
    _t.types = e;
    _t.studentId = _t.id;
    _t.dialogData.lesson_date = _t.detailsData.lesson_date;
    _t.dialogData.lesson_start_time = _t.detailsData.class_lesson.start_time;
    _t.dialogData.lesson_end_time = _t.detailsData.class_lesson.end_time;
    _t.dialogData.consume_number = _t.detailsData.consume_number;
    _t.dialogData.consume_class = _t.detailsData.class_lesson_extend.content;
    _t.disabled = true;
  }
  goBacks(e: any) {
    const _t = this as any;
    if (e == "edit") {
      _t.getData(_t.id);
    }
    _t.disabled = false;
  }
  getexceedcode() {
    const _t = this;
    exceedcode().then((res: any) => {
      if (res.error_code == 0) {
        _t.codeList = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getTime(e: any) {
    return dateFormat("YYYY-mm-dd", e);
  }
  changeStudentStatus(e: any, type: number) {
    e.student_status = type;
  }
  lookDetails(e: any, type: string, ind: number) {
    const _t = this as any;
    if (type == "class") {
      studentExceedHandle({
        roll_call_student_id: e.roll_call_student_id,
      }).then((res: any) => {
        if (res.error_code == 0) {
          _t.$message({
            type: "success",
            message: "扣课成功",
          });
          _t.init();
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    } else if (type == "keep") {
      if (!this.student_exceed) {
        // 关闭超上的时候, 耗课数 > 总课时(剩余课时 + 上次消耗的课时)
        if (
          Number(e.consume_number) >
          Number(e.usable_number) + Number(this.courseNum)
        ) {
          _t.$message({
            type: "error",
            message: "耗课数不可超过剩余课时",
          });
          this.tableData[ind].superupperColor = true;
          return;
        }
      }
      if (e.student_type != 5) {
        if (!/^\d+(\.\d{1,2})?$/.test(e.consume_number)) {
          _t.$message({
            type: "error",
            message: "最多支持两位小数",
          });
          return;
        }
        if (e.consume_number == "" || e.consume_number < 0) {
          _t.$message({
            type: "error",
            message: "请正确输入耗课数",
          });
          return;
        }
      }
      if (e.remark.trim() == "") {
        _t.$message({
          type: "error",
          message: "请填写备注信息",
        });
        _t.tableData[ind].borderColor = true;
        return;
      }
      if (e.primeStatus != e.student_status) {
        _t.$confirm(
          `学员从"${
            ["到课", "迟到", "请假", "未到课"][e.primeStatus - 1]
          }"状态变为"${
            ["到课", "迟到", "请假", "未到课"][e.student_status - 1]
          }"状态，请确认实际耗课数是否正确！确定后修改签到状态。`,
          `签到状态变更`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            if (e.student_type != 5) {
              _t.postCourseAccount(e);
            } else {
              _t.clickrollcall(e);
            }
          })
          .catch(() => {});
      } else {
        if (e.student_type != 5) {
          _t.postCourseAccount(e);
        } else {
          _t.clickrollcall(e);
        }
      }
      this.surplusCourse = false;
    } else if (type == "close") {
      _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
      this.surplusCourse = false;
    } else if (type == "edit") {
      if (e.student_type !== 5) {
        courseAccount({
          student_id: e.student_id,
          course_id: e.course.course_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.surplusCourse = true;
            this.tableData[ind].usable_number = res.data.account.usable_number;
          }
        });
      }
      e.remark = e.remark == "-" ? "" : e.remark;
      e.sortBtn = true;
      e.primeStatus = e.student_status;
      this.courseNum = e.consume_number;
    }
  }
  postCourseAccount(e: any) {
    const _t = this;
    courseAccount({
      student_id: e.student_id,
      course_id: e.course.course_id,
    }).then((res: any) => {
      if (res.error_code == 0) {
        if (
          Number(e.consume_number) >
          Number(res.data.account.usable_number) + Number(this.courseNum)
        ) {
          _t.comfirClick(e);
        } else {
          _t.clickrollcall(e);
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  clickrollcall(e: any) {
    const _t = this as any;
    studentEdit({
      roll_call_student_id: e.roll_call_student_id,
      student_status: e.student_status,
      consume_number: e.consume_number,
      remark: e.remark,
    }).then((res: any) => {
      if (res.error_code == 0) {
        _t.$message({
          type: "success",
          message: "修改成功",
        });
        _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  comfirClick(e: any) {
    const _t = this as any;
    _t.$confirm(
      "学员剩余课时不足，修改后会导致课时超上，请及时联系学员续费。",
      `超上 - ${e.course.title}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        _t.clickrollcall(e);
      })
      .catch(() => {});
  }
  getrollcallstudentlist(data: rollCallListData) {
    const _t = this as any;
    data.roll_call_id = _t.id;
    rollCallStudentList(data).then((res: any) => {
      if (res.error_code == 0) {
        res.data.list.map((a: any) => {
          a.remark = a.remark == "" ? "-" : a.remark;
          a.sortBtn = false;
          switch (a.student_status) {
            case 1:
              a.student_statusName = "到课";
              break;
            case 2:
              a.student_statusName = "迟到";
              break;
            case 3:
              a.student_statusName = "请假";
              break;
            case 4:
              a.student_statusName = "未到课";
              break;
          }
        });
        res.data.list.map((item: any) => {
          item.borderColor = false;
          item.usable_number = 0;
          item.superupperColor = false;
        });
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getData(id: number) {
    const _t = this as any;
    rollCallDetails({ roll_call_id: id }).then((res: any) => {
      if (res.error_code == 0) {
        const i = new Date(res.data.lesson_date.replace(/-/g, "/")).getDay();
        res.data.weekZh = ["日", "一", "二", "三", "四", "五", "六"][i];
        // res.data.class_lesson.start_time = res.data.class_lesson.start_time.slice(0, 5);
        // res.data.class_lesson.end_time = res.data.class_lesson.end_time.slice(0, 5);
        _t.detailsData = res.data;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  handleClick(tab: any, event: any) {
    const _t = this as any;
    _t.page = 1;
    _t.pageSize = 10;
    if (_t.id) {
      _t.getListData();
    }
  }
  getListData() {
    const _t = this as any;
    _t.tableData = [];
    switch (_t.activeName) {
      case "studentlist":
        _t.getrollcallstudentlist({ page: _t.page, page_size: _t.pageSize });
        break;
      case "modifyrecord":
        _t.getexceedHandle({
          page: _t.page,
          page_size: _t.pageSize,
        });
        break;
    }
  }
  getexceedHandle(parmas: getOperationLogInter) {
    const _t = this as any;
    const number = [60000, 60001];
    parmas.page = 1;
    parmas.page_size = 1000;
    parmas.code = number;
    parmas.relation_id = _t.id;
    getOperationLogApi(parmas).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            _t.codeList.map((b: any) => {
              if (a.code == b.key) {
                a.codeName = b.value;
              }
            });
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getListData();
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getListData();
  }
  // 撤销点名
  delRollCall(rollCallInfo: any) {
    this.$confirm(
      `撤销点名记录后，将退还未结课学员课时及金额，确定要撤销点名？`,
      `撤销点名 - ${rollCallInfo.class.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        lessonCancelRollCall({
          roll_call_id: rollCallInfo.roll_call_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              message: "撤销成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        });
      })
      .catch(() => {});
  }
}
